export const mapDocumentsToUploadedFiles = (documents = {}) => {
  const uploadedFiles = {};

  Object.entries(documents).forEach(
    ([documentId, document]) => {
      if (!document) return;

      // BOTH
      if (
        document.frontUrl ||
        document.backUrl
      ) {
        uploadedFiles[documentId] = {
          front: document.frontUrl
            ? {
                name: `${documentId}-front`,
                url: document.frontUrl,
                isExisting: true,
              }
            : null,

          back: document.backUrl
            ? {
                name: `${documentId}-back`,
                url: document.backUrl,
                isExisting: true,
              }
            : null,
        };

        return;
      }

      // MULTIPLE
      if (
        Array.isArray(document.urls)
      ) {
        uploadedFiles[documentId] = {
          multiple: document.urls.map(
            (url, index) => ({
              name:
                url?.split("/").pop() ||
                `${documentId}-${index + 1}`,
              url,
              isExisting: true,
            })
          ),
        };

        return;
      }

      // SINGLE
      if (document.url) {
        uploadedFiles[documentId] = {
          single: {
            name:
              document.url
                .split("/")
                .pop() ||
              documentId,
            url: document.url,
            isExisting: true,
          },
        };
      }
    }
  );

  return uploadedFiles;
};